import { useState } from "react";
import { InputField } from "../input";

type FormData = {
  name: string;
  email: string;
  phone: string;
};

export const Form: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    phone: "",
  });

  const formatPhoneNumber = (value: string) => {
    const numbers = value.replace(/\D/g, "");
    if (numbers.length === 0) return ``;
    if (numbers.length <= 2) return `(${numbers}`;
    if (numbers.length <= 7)
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(
      7,
      11
    )}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "phone" ? formatPhoneNumber(value) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Dados do formulário:", formData);
  };

  return (
    <div id="contact" className="py-10 px-4 lg:px-0 flex justify-center">
      <div className="flex flex-col md:flex-row items-center justify-between w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <div className="md:w-1/2 text-left mb-6 md:mb-0 px-4 md:px-0">
          <h2 className="text-2xl font-bold mb-4 text-black leading-tight">
            Qualquer dúvida ou quiser saber mais sobre essa pesquisa, envie-nos
            uma mensagem ou um e-mail, e entraremos em contato com você.
          </h2>
        </div>
        <div className="md:w-1/2 w-full px-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <InputField
              type="text"
              name="name"
              placeholder="Seu Nome"
              value={formData.name}
              onChange={handleChange}
            />
            <InputField
              type="email"
              name="email"
              placeholder="exemplo@email.com"
              value={formData.email}
              onChange={handleChange}
            />
            <InputField
              type="text"
              name="phone"
              placeholder="(__) _____-____"
              value={formData.phone}
              onChange={handleChange}
              maxLength={20}
            />
            <button
              type="submit"
              className="w-full p-3 bg-blue-500 text-white rounded-full shadow-md hover:bg-blue-600 transition"
            >
              Entre em contato
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
